import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

import { Redirect } from "react-router-dom"

// Applicant Information Redux States
import {
    APPLICATION_RESET_STATE,
    APPLICATION_PERSONAL_INFORMATION,
    APPLICATION_UPDATE_ADDRESS,
    APPLICATION_INCOME_INFORMATION,
    APPLICATION_RESIDENCY_INFORMATION,
    APPLICATION_REFERENCE_INFORMATION,
    APPLICATION_ACCESS_CODE,
    APPLICATION_VALIDATE_ACCESS_CODE,
    APPLICATION_START_CO_SIGNER,
    APPLICATION_INVITE_CO_EMAIL,
    APPLICATION_INVITE_CO_SMS,
} from "./actionTypes"

import {
    applicationResetStateSuccessful,
    applicationResetStateFailed,
    applicationPersonalInformationSuccessful,
    applicationPersonalInformationFailed,
    applicationUpdateAddressSuccessful,
    applicationUpdateAddressFailed,
    applicationIncomeInformationFailed,
    applicationIncomeInformationSuccessful,
    applicationResidencyInformationSuccessful,
    applicationResidencyInformationFailed,
    applicationReferenceInformationSuccessful,
    applicationReferenceInformationFailed,
    applicationAccessCodeSuccessful,
    applicationAccessCodeFailed,
    applicationValidateAccessCodeSuccessful,
    applicationValidateAccessCodeFailed,
    applicationStartCoSignerSuccessful,
    applicationStartCoSignerFailed,
    applicationInviteCoEmailSuccessful,
    applicationInviteCoEmailFailed,
    applicationInviteCoSmsSuccessful,
    applicationInviteCoSmsFailed,
} from "./actions"

import {
    fnSetPersonalInformation,
    fnUpdateAddress,
    fnSetIncomeInformation,
    fnSetResidencyInformation,
    fnSetReferenceInformation,
    fnDeliverAccessCode,
    fnValidateAccessCode,
    fnInviteCoEmail,
    fnInviteCoSms,
} from "../../helpers/Application/applicationService"

import {
  reset,
  setSession,
  getSession,
} from "../../helpers/AuthType/authService"

/* Resets state */
function* applicationResetState({ payload: { path, history } }) {
  try {
    yield put(applicationResetStateSuccessful())

    if(path)
      history(path)
  } catch (error) {
    yield put(applicationResetStateFailed(error.message))
  }
}

/* Update address */
function* applicationUpdateAddress({ payload: { applicantType, address, history } }) {
  try {
    const applicant = yield call(fnUpdateAddress, {applicantType, address})

    var path = applicant.key == "coapplicant" ? "/co/income-information" : "/income-information";

    yield put(applicationUpdateAddressSuccessful(applicant))

    history(path)
    
  } catch (error) {
    yield put(applicationUpdateAddressFailed(error.message))
  }
}

function* applicationPersonalInformation({ payload: { applicant, history } }) {
  try {
    
    const {addressVerification} = yield call(fnSetPersonalInformation, applicant)

    var path = applicant.key == "coapplicant" ? "/co/income-information" : "/income-information";
    
    yield put(applicationPersonalInformationSuccessful(addressVerification))
    
    if (addressVerification.addressMatch) history(path)

  } catch (error) {
    yield put(applicationPersonalInformationFailed(error.message))
  }
}

function* applicationIncomeInformation({ payload: { applicantType, income, history } }) {
  try {
    
    const response = yield call(fnSetIncomeInformation, income)

    var path = applicantType == "coapplicant" ? "/co/residency-information" : "/residency-information";
    
    yield put(applicationIncomeInformationSuccessful(response))
    
    history(path)

  } catch (error) {
    console.log({ error : error.message })
    yield put(applicationIncomeInformationFailed(error.message))
  }
}

function* applicationResidencyInformation({ payload: { applicantType, residency, history } }) {
  try {
    
    const response = yield call(fnSetResidencyInformation, residency)

    var path = applicantType == "coapplicant" ? "/co/reference-information" : "/reference-information";
    
    yield put(applicationResidencyInformationSuccessful(response))
    
    history(path)

  } catch (error) {
    console.log({ error : error.message })
    yield put(applicationResidencyInformationFailed(error.message))
  }
}

function* applicationReferenceInformation({ payload: { applicantType, reference, history } }) {
  try {
    
    const response = yield call(fnSetReferenceInformation, { applicantType, reference})

    var path = applicantType == "coapplicant" ? "/co/access-code" : "/access-code";
    
    yield put(applicationReferenceInformationSuccessful(response))
    
    history(path)

  } catch (error) {
    console.error({ error : error.message })
    yield put(applicationReferenceInformationFailed(error.message))
  }
}

function* applicationAccessCode({ payload: { applicantType, data, history } }) {
  try {
    let {access_code_method} = data;
    
    const response = yield call(fnDeliverAccessCode, { applicantType, access_code_method})

    var path = applicantType == "coapplicant" ? "/co/validate-access-code" : "/validate-access-code";
    
    yield put(applicationAccessCodeSuccessful(response))
    
    history(path)

  } catch (error) {
    console.error({ error : error.message })
    yield put(applicationAccessCodeFailed(error.message))
  }
}

function* applicationValidateAccessCode({ payload: { applicantType, data, history } }) {
  try {
    
    const response = yield call(fnValidateAccessCode, { applicantType, data})

    var path = applicantType == "coapplicant" ? "/logout" : "/add-cosigner";
    
    yield put(applicationValidateAccessCodeSuccessful(response))
    
    history(path)

  } catch (error) {
    console.error({ error : error.message })
    yield put(applicationValidateAccessCodeFailed(error.message))
  }
}

function* applicationStartCoSigner({ payload: { applicantType, data, history } }) {
  try {

    if(applicantType.includes(['coapplicant']))
      throw new Error('Invalid applicant')

    let {url_identifier} = data

    var path = `/sign-up/co/${url_identifier}`;
    
    yield put(applicationStartCoSignerSuccessful({url_identifier}))
    
    history(path)

  } catch (error) {
    console.error({ error : error.message })
    yield put(applicationStartCoSignerFailed(error.message))
  }
}

function* applicationInviteCoEmail({ payload: { applicantType, data, history } }) {
  try {
    
    const response = yield call(fnInviteCoEmail, { applicantType, data})
    
    yield put(applicationInviteCoEmailSuccessful(response))

  } catch (error) {
    console.error({ error : error.message })
    yield put(applicationInviteCoEmailFailed(error.message))
  }
}

function* applicationInviteCoSms({ payload: { applicantType, data, history } }) {
  try {
    
    const response = yield call(fnInviteCoSms, { applicantType, data})
    
    yield put(applicationInviteCoSmsSuccessful(response))

  } catch (error) {
    console.error({ error : error.message })
    yield put(applicationInviteCoSmsFailed(error.message))
  }
}

function* appliocationSaga() {
  yield takeEvery(APPLICATION_RESET_STATE, applicationResetState)
  yield takeEvery(APPLICATION_PERSONAL_INFORMATION, applicationPersonalInformation)
  yield takeEvery(APPLICATION_UPDATE_ADDRESS, applicationUpdateAddress)
  yield takeEvery(APPLICATION_INCOME_INFORMATION, applicationIncomeInformation)
  yield takeEvery(APPLICATION_RESIDENCY_INFORMATION, applicationResidencyInformation)
  yield takeEvery(APPLICATION_REFERENCE_INFORMATION, applicationReferenceInformation)
  yield takeEvery(APPLICATION_ACCESS_CODE, applicationAccessCode)
  yield takeEvery(APPLICATION_VALIDATE_ACCESS_CODE, applicationValidateAccessCode)
  yield takeEvery(APPLICATION_START_CO_SIGNER, applicationStartCoSigner)
  yield takeEvery(APPLICATION_INVITE_CO_EMAIL, applicationInviteCoEmail)
  yield takeEvery(APPLICATION_INVITE_CO_SMS, applicationInviteCoSms)
}

export default appliocationSaga
